// import HouseModel from "../../../static/model/musNew.glb";
import HouseModel from "../../../static/model/mus_new_nodraco3.glb";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {
  TextureLoader,
  MeshBasicMaterial,
  DoubleSide,
  CanvasTexture,
  PlaneGeometry,
  Mesh,
} from "three";
import TWEEN from "@tweenjs/tween.js";
import SpriteTexture from "../../../static/img/click.png";
import {config} from "../config";
import Frame from "../../../static/img/frameTexture3.png";

export default class Loader {
  constructor(viewer) {
    this.viewer = viewer;
    this.loader = new GLTFLoader();
    this.loaderTexture = new TextureLoader();
    this.time = new Date().getTime();
    this.counter = 0;
    this.point = {};
    this.textureFrame = new TextureLoader().load(Frame)
    this.spriteMap = new TextureLoader().load(SpriteTexture);
    this.material = new MeshBasicMaterial({
      transparent: true,
      map: this.spriteMap,
      side: DoubleSide,
    });
  }

  loadModel() {
    this.loader.load(HouseModel, (gltf) => {
      this.viewer.loader = false;
      document.getElementById('loaderWrap').classList.add('none');
      if (this.viewer.musIn) {
        this.viewer.sound.play();
        this.viewer.mobJoystick.classList.remove('none')
        setTimeout(() => {
          if (this.viewer.mobile) {
            this.viewer.tutorial.classList.add('none');
          } else {
            this.viewer.tutorialMob.classList.add('none');
          }
        }, 40000)
      }
      gltf.scene.position.set(-13.5, 0, 7.3);
      this.viewer.scene.add(gltf.scene);
      const model = gltf.scene
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 500)

      model.traverse((el) => {
        if (el.isMesh) {

          if (el.name.match("_1") && el.name !== 'path373002_1') {
            this.quaternion = el.parent.quaternion;
            this.data = config[el.name];

            const sprite = new Mesh(
                new PlaneGeometry(1, 1),
                new MeshBasicMaterial({map: this.spriteMap, color: 'white', side: DoubleSide})
            );
            sprite.position.copy(el.parent.getWorldPosition());
            sprite.scale.set(0.1, 0.1, 0.1);
            sprite.material.color.setRGB(2, 2, 2)
            sprite.material.transparent = true
            this.viewer.scene.add(sprite);
            this.viewer.meshOnScene.push(sprite)

            if (this.viewer.mobile) {
              this.plane = new Mesh(
                  new PlaneGeometry(1.3, 0.29),
                  new MeshBasicMaterial({side: DoubleSide, visible: false})
              );
              this.plane.position.copy(el.parent.getWorldPosition());
              this.viewer.scene.add(this.plane);
              this.viewer.meshOnScene.push(this.plane)
            }


            let size = {
              x:
                  el.geometry.boundingBox.max.x -
                  el.geometry.boundingBox.min.x,
              y:
                  el.geometry.boundingBox.max.y -
                  el.geometry.boundingBox.min.y,
              z:
                  el.geometry.boundingBox.max.z -
                  el.geometry.boundingBox.min.z,
            };

            new TWEEN.Tween({ scale: 0.665 })
                .to({ scale: 1.5 }, 1000)
                .easing(TWEEN.Easing.Quartic.InOut)
                .repeat(Infinity)
                .onUpdate((value) => {
                  if (value.scale < 1) {
                    sprite.scale.set(
                        0.1 / value.scale,
                        0.1 / value.scale,
                        0.1 / value.scale
                    );
                  } else {
                    sprite.scale.set(
                        0.1 * value.scale,
                        0.1 * value.scale,
                        0.1 * value.scale
                    );
                  }
                })
                .start();

            sprite.position.y -= size.y / 2;
            if (el.name === "pic3_1") {
              sprite.position.y -= 0.45;
            } else if (el.name === "pic12_1") {
              sprite.position.y -= 0.33;
            } else {
              sprite.position.y -= 0.2;
            }

            sprite.name = el.name;

            if (this.viewer.mobile) {
              this.plane.position.y -= size.y / 2;
              this.plane.position.y -= 0.15;
              this.plane.name = el.name;
            }

            this.point[el.name] = sprite;
            this.curent = sprite;

            let info = '';
            this.data.description.forEach((item) => {
              info += item + '\n';
            });

            this.canvas = document.createElement('canvas');
            this.canvas.width = 850;
            this.canvas.height = 110;
            this.ctx = this.canvas.getContext('2d');

            this.materialTexture = new MeshBasicMaterial({map: new CanvasTexture(this.canvas)});
            let geomTexture = new PlaneGeometry(1.48, 0.32);
            this.meshTexture = new Mesh(geomTexture, this.materialTexture)
            this.meshTexture.material.toneMapped = false;
            this.viewer.scene.add(this.meshTexture);

            let frameMat = new MeshBasicMaterial({map: this.textureFrame});
            let frameGeom = new PlaneGeometry(1.3, 0.27);
            this.frameMesh = new Mesh(frameGeom, frameMat)
            this.frameMesh.material.color.setRGB(0.3, 0.3, 0.3)
            this.frameMesh.material.transparent = true;
            this.frameMesh.scale.set(1.25, 1.27, 1);
            this.viewer.scene.add(this.frameMesh);

            this.x = 840;
            if (info.length <= 60) {
              this.canvas.width = 550
              this.x = 540
              this.y = 45;
            } else if (info.length <= 63) {
              this.canvas.width = 610
              this.x = 600
              this.y = 45;
            } else if (info.length <= 69) {
              this.canvas.width = 680
              this.x = 670
              this.y = 45;
            } else if (info.length <= 73) {
              this.canvas.width = 720
              this.x = 710
              this.y = 45;
            } else if (info.length <= 76 && info.length >= 73) {
              this.canvas.width = 770
              this.x = 760
              this.y = 45;
            } else if (info.length >= 134) {
              this.y = 30;
              this.canvas.width = 960
              this.x = 950
            } else {
              this.y = 45;
              this.canvas.width = 850
              this.x = 840
            }
            // this.y = 30;
            var lineheight = 35;
            var lines = info.split('\n');

            this.ctx.font = `600 30px serif`;
            this.ctx.fillStyle = "white";
            this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
            this.ctx.fillStyle = "black";
            this.ctx.textAlign = "right";
            for (var i = 0; i < lines.length; i++) {
              if (lines.length >= 4) {
                this.ctx.fillText(lines[i], this.x, 32 + (i * lineheight))
              } else {
                this.ctx.fillText(lines[i], this.x, this.y + (i * lineheight))
              }
            };
            this.materialTexture.map.image = this.canvas;
            this.materialTexture.map.needsUpdate = true;
            this.materialTexture.needsUpdate = true;
            this.frameMesh.position.copy(this.curent.position);

            this.meshTexture.setRotationFromQuaternion(this.quaternion)
            this.frameMesh.setRotationFromQuaternion(this.quaternion);
            if (this.meshTexture.rotation.y === 0) {
              this.meshTexture.rotation.y = Math.PI
              this.frameMesh.rotation.y = Math.PI
              this.frameMesh.position.z -= 0.02
              if (this.viewer.mobile) {
                this.plane.rotation.y = Math.PI;
                this.plane.position.z -= 0.01
              }
              sprite.rotation.y = Math.PI;
              sprite.position.z -= 0.01
            } else if (this.meshTexture.rotation.y === 3.2584136988589884e-7) {
              this.meshTexture.rotation.y = -Math.PI
              this.frameMesh.rotation.y = -Math.PI
              this.frameMesh.position.z += 0.02
              if (this.viewer.mobile) {
                this.plane.rotation.y = -Math.PI;
                this.plane.position.z += 0.01
              }
              sprite.rotation.y = -Math.PI;
              sprite.position.z += 0.01
            } else if (this.meshTexture.rotation.y === -1.5705346837209222) {
              this.meshTexture.rotation.y = Math.PI / 2
              this.frameMesh.rotation.y = Math.PI / 2
              this.frameMesh.position.x += 0.02
              if (this.viewer.mobile) {
                this.plane.rotation.y = Math.PI / 2;
                this.plane.position.x += 0.01
              }
              sprite.rotation.y = Math.PI / 2;
              sprite.position.x += 0.01
            } else if (this.meshTexture.rotation.y === 1.5705346830691562) {
                this.meshTexture.rotation.y = -Math.PI / 2
                this.frameMesh.rotation.y = -Math.PI / 2
                this.frameMesh.position.x -= 0.02
                if (this.viewer.mobile) {
                    this.plane.rotation.y = -Math.PI / 2;
                    this.plane.position.x -= 0.01
                }
                sprite.rotation.y = -Math.PI / 2;
                sprite.position.x -= 0.01
            } else if (this.meshTexture.rotation.y === 1.5705346837209222) {
              this.meshTexture.rotation.y = -Math.PI / 2
              this.frameMesh.rotation.y = -Math.PI / 2
              this.frameMesh.position.x -= 0.02
              if (this.viewer.mobile) {
                this.plane.rotation.y = -Math.PI / 2;
                this.plane.position.x -= 0.01
              }
              sprite.rotation.y = -Math.PI / 2;
              sprite.position.x -= 0.01
            }

            this.meshTexture.position.copy(this.curent.position);
            this.meshTexture.position.y -= 0.275
            this.frameMesh.position.y -= 0.27
          }

          if (el.name === "floor_nav") {
            el.material.transparent = true;
            el.material.opacity = 0;
          }
          if (el.name === "Plane002") {
            el.material.transparent = true;
          }
          if (el.name === "Floor003") {
            el.material = el.material.clone();
            el.material.metalness = 0;
            el.material.transparent = true;
            el.material.opacity = 0.9;
            el.material.emissive.setRGB(0.1, 0.1, 0.1);
            el.material.color.setRGB(1, 1, 1);
            el.material.emissiveIntensity = 1.5
          }

          if (el.name.includes("point_")) {
          } else {
            if (!el.name.includes("Plane_")) {
              this.viewer.meshOnScene.push(el)
            };
          }
        }
      });
    });
  }
}
